import { callAction } from './client';
import { Category } from './types';

/**
 * NOTE: lambda.py has no `get_categories` action yet (only get_locations,
 * get_menu, get_news are registered in ACTIONS). Add a `get_categories`
 * handler to lambda.py and redeploy before calling this, otherwise the
 * lambda will respond with a 400 "action must be one of: [...]" error.
 */
export function getCategories(): Promise<Category[]> {
  return callAction<Category[]>('get_categories');
}
